module.exports = __webpack_public_path__ + "media/icons/facebook-e19917a6.svg";